export default {
  supportedLngs: ['en', 'ja'],
  fallbackLng: 'en',
  defaultNS: 'login',
};
